import { Modal } from "react-bootstrap";
import { Button } from "@jauntin/react-ui";

const ModalPaymentExpiry = ({ show }: { show: boolean }) => {
  return (
    <Modal show={show}>
      <Modal.Body>
        <div className="container d-flex flex-column justify-content-center align-items-center">
          <p className="mb-3">
            Your payment session has timed out. Please refresh the page and
            re-enter your payment information.
          </p>
          <Button
            className="btn btn-primary"
            onClick={() => {
              window.location.reload();
            }}
            text={"Refresh Page"}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPaymentExpiry;
